import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Badge from 'base-ui/dist/Badge';
import Col from 'base-ui/dist/Col';
import Row from 'base-ui/dist/Row';
import get from 'base-ui/dist/underline/get';
import CoursesLink from 'components/CoursesLink';
import Image from 'components/Image';
import IsOnline from './IsOnline';
import Rating from './Rating';
import Campaign from './Campaign';
import BuyButton from './BuyButton';
import NaturalList from './NaturalList';
import messages from './messages';

function Course({ articleUrl, source, campaign, medium, categoriesName, item, instructorsName, style, buttonText }) {
  return (
    <Fragment>
      <article className="content-post course">
        <CoursesLink
          toRoute={articleUrl}
          source={source}
          campaign={campaign}
          medium={medium}
          style={{ fontWeight: 'initial' }}
          courseName={item.name}
        >
          <div className="thumb">
            <Badge className="alpha-bg-inverse white-color normal-font cat">
              <NaturalList list={categoriesName} />
            </Badge>
            <div className="thumb-wrap">
              <Image
                src={get(item, 'widget.image', item.image)}
                alt={item.name}
                lazy
                className="thumb-bg"
              />
            </div>
          </div>

          <div
            className="course-caption"
            style={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <span className="course-title">
              <Badge className="main-bg white-color font-small main-font text-uppercase font-small">
                <FormattedMessage {...messages.topSales} />
              </Badge>
              {get(item, 'widget.title', item.name)}
            </span>
            <span className="subline">
              <FormattedMessage {...messages.aCourseBy} />
              {' '}
              <NaturalList list={instructorsName} />
            </span>
            <span
              className="excerpt"
              style={{ fontSize: '.825rem', flex: '1' }}
            >
              {item.subtitle || ' '}
            </span>
            <Row className="metas bottom-xs">
              <Col xs={6} sm={12}>
                <IsOnline type={item.type} />
                <Rating likes={item.total} likeRate={item.likeRate} />
              </Col>
              <Col
                xs={6}
                sm={7}
                className="margin-top-small end-xs start-sm"
                style={style}
              >
                <Campaign price={item.price} campaign={item.campaign} />
              </Col>
              <Col
                xs={12}
                sm={5}
                className="margin-top-small end-sm"
              >
                <BuyButton
                  price={item.price}
                  campaignItem={item.campaign}
                  slug={item.slug}
                  source={source}
                  campaign={campaign}
                  medium={medium}
                  buttonText={buttonText}
                  courseName={item.name}
                />
              </Col>
            </Row>
          </div>
        </CoursesLink>
      </article>
      <hr className="transparent-bg" />
    </Fragment>
  );
}

Course.propTypes = {
  campaign: PropTypes.object,
  articleUrl: PropTypes.string,
  source: PropTypes.string,
  medium: PropTypes.string,
  categoriesName: PropTypes.string,
  item: PropTypes.object,
  instructorsName: PropTypes.any,
  style: PropTypes.any,
  buttonText: PropTypes.string,
};

export default Course;
